export const playerNounUppercase = 'Player';
export const playerNounLowerCase = 'player';
